import { render, staticRenderFns } from "./JournalLanding.vue?vue&type=template&id=b4e80c02&"
import script from "./JournalLanding.vue?vue&type=script&lang=js&"
export * from "./JournalLanding.vue?vue&type=script&lang=js&"
import style0 from "./JournalLanding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports